import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";
import AutocompleteGo from "../Autocomplete/AutocompleteGo";
//import rSlider from "../rSlider/rSlider";
//import "../rSlider/rSlider.css";

export const FilterType = {
  OptionCheck: 1,
  OptionRadio: 2,
  AutoComplete: 3,
  Range: 4,
  Date: 5,
};

const TableOptionCheck = forwardRef(
  (
    {
      item,
      filterType = FilterType.OptionCheck,
      options,
      onClick,
      onChange,
      checked = false,
      names = "",
      sliderValues = [0, 50, 100, 150, 200, 250, 300],
    },
    ref
  ) => {
    console.log("--> BLEh");
    const itemId = `${item.nombre}${String(item.id)}${names}`;

    const menu2Ref = useRef(null);
    const sliderRef = useRef(null);
    const sliderInputRef = useRef(null);
    const refAutocomplete = useRef(null);
    const openFirstTime = useRef(true);

    useImperativeHandle(ref, () => ({
      resize: () => {
        resizeRange();
      },
      clearInput() {
        refAutocomplete.current?.clearInput();
      },
    }));

    useEffect(() => {
      /*if (filterType === FilterType.Range && sliderRef.current === null) {
        sliderRef.current = new window.rSlider({
          target: "#slider",
          values: [0, 50, 100, 150, 200, 250, 300],
          range: true, // range slider
          set: [2010, 2013],
          onChange: function (vals) {
            console.log(vals);
          },
        });
      }*/

      addEventListeners();
      return () => {
        removeEventListeners();
      };
    }, []);

    function buttonDropDownParent() {
      const found =
        menu2Ref.current?.parentElement.parentElement.querySelectorAll(
          ".dropdown-toggle"
        );
      return found !== undefined ? found[0] : null;
    }

    function addEventListeners() {
      if (filterType !== FilterType.Range) return;

      buttonDropDownParent()?.addEventListener(
        "shown.bs.dropdown",
        handleShowMenu
      );
      //  menu2Ref.current.addEventListener("hide.bs.dropdown", handleHideMenu);
    }

    const removeEventListeners = () => {
      if (filterType !== FilterType.Range) return;
      buttonDropDownParent()?.removeEventListener(
        "shown.bs.dropdown",
        handleShowMenu
      );
      //  menu2Ref.current.removeEventListener("hide.bs.dropdown", handleHideMenu);
    };

    const handleShowMenu = (event, item, options) => {
      if (!openFirstTime.current) {
        setTimeout(function () {
          resizeRange();
        }, 500);
        return;
      }

      openFirstTime.current = !openFirstTime.current;
      resizeRange();
      setTimeout(function () {
        resizeRange();
      }, 500);
    };

    function resizeRange() {
      if (filterType === FilterType.Range && sliderRef.current === null) {
        sliderRef.current = new window.rSlider({
          target: sliderInputRef.current,
          values: sliderValues,
          range: true, // range slider
          set: [2010, 2013],
          onChange: function (vals) {
            console.log(vals);
            onChange(vals);
          },
        });
      }

      sliderRef.current.onResize();
    }

    if (filterType === FilterType.Range) {
      return (
        <li ref={menu2Ref} style={{ width: "500px" }}>
          <div
            className="slider-container"
            style={{ width: "90%", maxWidth: "600px", margin: "0 auto 50px" }}
          >
            <input ref={sliderInputRef} type="text" className="slider" />
          </div>
        </li>
      );
    }

    return (
      <li>
        {filterType !== FilterType.AutoComplete && (
          <span
            className="dropdown-item"
            style={{
              display: "flex",
              paddingTop: "0px",
              paddingBottom: "0px",
              columnGap: "12px",
            }}
          >
            {filterType === FilterType.OptionCheck && (
              <>
                <input
                  type="checkbox"
                  name="removeFromGroup[]"
                  className="removeFromGroup"
                  value=""
                  checked={item.checked}
                  onClick={(event) => {
                    onClick(event, item, options);
                    // modalButtonRef.current.click();
                  }}
                  onChange={() => {}}
                  id={itemId}
                ></input>
                <label
                  htmlFor={itemId}
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    flexGrow: "1",
                  }}
                >
                  {item.nombre}
                </label>
              </>
            )}

            {filterType === FilterType.OptionRadio && (
              <>
                <input
                  type="radio"
                  name={names}
                  className="aGroup"
                  value=""
                  onClick={(event) => {
                    console.log("--> " + names + " : " + itemId);
                    onClick(event, item, options);
                    // modalButtonRef.current.click();
                  }}
                  id={itemId}
                  checked={checked}
                  onChange={() => {}}
                ></input>
                <label
                  htmlFor={itemId}
                  style={{
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    flexGrow: "1",
                  }}
                >
                  {item.nombre}
                </label>
              </>
            )}
          </span>
        )}

        {filterType === FilterType.AutoComplete && (
          <>
            <AutocompleteGo
              ref={refAutocomplete}
              options={options}
              onChange={(e) => {
                //formik.setFieldValue("sucursal", e);
                console.log(e);
                onChange(e, item);
              }}
              style={{ width: "300px" }}
            />
          </>
        )}
      </li>
    );
  }
);

export default TableOptionCheck;
